import React from 'react';

import CSSModules from 'react-css-modules';

import Text from '../../../TextComponents/Text';
import {OrderingAnswerIcon} from './Icons';

import styles from './styles.module.scss';

type OrderingAnswerProps = {
  text: string;
  isReviewing: boolean;
  isCorrect: boolean;
  isDragging: boolean;
  disabled: boolean;
  dataAutomation: string;
  isPreview: boolean;
  accessibilityLabels: {
    icon: {
      correct: string;
      incorrect: string;
    };
  };
};

const OrderingAnswer = ({
  text,
  isReviewing,
  isCorrect,
  isDragging,
  disabled,
  dataAutomation,
  isPreview,
  accessibilityLabels,
}: OrderingAnswerProps): JSX.Element => {
  let styleName = 'ordering-answer' + (isCorrect ? ' correct' : ' incorrect');
  if (isReviewing) {
    styleName += ' reviewing';
  }
  if (isDragging) {
    styleName += ' dragging';
  }
  if (disabled) {
    styleName += ' disabled';
  }
  if (isPreview) {
    styleName += ' preview-mode';
  }

  return (
    <div styleName={styleName} data-automation={dataAutomation}>
      <Text size='m' weight='medium'>
        {text}
      </Text>
      <div styleName='iconContainer'>
        <OrderingAnswerIcon
          isCorrect={isCorrect}
          accessibilityLabels={accessibilityLabels}
        />
      </div>
    </div>
  );
};

export default CSSModules(OrderingAnswer, styles, {allowMultiple: true});
